/**
 * Route for `first-click-attribution`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FirstClickAttributionPage } from "../features/first-click-attribution/FirstClickAttributionPage";

export const firstClickAttributionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/first-click-attribution",
	component: FirstClickAttributionPage,
});

export default firstClickAttributionRoute;
